import {
  IconAlignJustified,
  IconBorderCorners,
  IconCrystalBall,
  IconCustomAlignJustifiedCheck,
  IconCustomBorderCornersCheck,
  IconCustomButton,
  IconCustomCrystalBallCheck,
  IconCustomCrystalBallEdited,
  IconCustomCrystalBallRibbon,
  IconCustomDatabaseCheck,
  IconCustomDatabaseRibbon,
  IconCustomLayoutGridCheck,
  IconCustomLayoutListCheck,
  IconCustomMathFunctionCheck,
  IconCustomMathFunctionEdit,
  IconCustomMathFunctionRibbon,
  IconCustomSquareLetterECheck,
  IconCustomTableCheck,
  IconDatabaseSearch,
  IconLayoutGrid,
  IconLayoutList,
  IconMathFunction,
  IconProgress,
  IconProgressCheck,
  IconSection,
  IconSquareLetterE,
  IconTable,
  TablerIcon,
} from '@rossum/ui/icons/tabler';
import { SvgIcon, SvgIconProps } from '@rossum/ui/material';

export type SchemaFieldIconType =
  | 'simpleValue'
  | 'multiValue'
  | 'lineItem'
  | 'unset'
  | 'button'
  | 'captured'
  | 'manual'
  | 'data'
  | 'einvoicing'
  | 'formula'
  | 'reasoning'
  | 'lookup';

export type SchemaFieldIconVariant =
  | 'default'
  | 'confirmed'
  | 'edited'
  | 'saved';

const fieldIcons: Record<
  SchemaFieldIconType,
  Partial<Record<SchemaFieldIconVariant, TablerIcon>>
> = {
  // field types
  simpleValue: {
    default: IconSection,
  },
  multiValue: {
    default: IconLayoutList,
    confirmed: IconCustomLayoutListCheck,
  },
  lineItem: {
    default: IconTable,
    confirmed: IconCustomTableCheck,
  },
  button: {
    default: IconCustomButton,
  },
  // value sources
  unset: {
    default: IconProgress,
    confirmed: IconProgressCheck,
  },
  captured: {
    default: IconBorderCorners,
    confirmed: IconCustomBorderCornersCheck,
  },
  manual: {
    default: IconAlignJustified,
    confirmed: IconCustomAlignJustifiedCheck,
  },
  data: {
    default: IconLayoutGrid,
    confirmed: IconCustomLayoutGridCheck,
  },
  einvoicing: {
    default: IconSquareLetterE,
    confirmed: IconCustomSquareLetterECheck,
  },
  formula: {
    default: IconMathFunction,
    confirmed: IconCustomMathFunctionCheck,
    edited: IconCustomMathFunctionEdit,
    saved: IconCustomMathFunctionRibbon,
  },
  reasoning: {
    default: IconCrystalBall,
    confirmed: IconCustomCrystalBallCheck,
    edited: IconCustomCrystalBallEdited,
    saved: IconCustomCrystalBallRibbon,
  },
  lookup: {
    default: IconDatabaseSearch,
    confirmed: IconCustomDatabaseCheck,
    edited: IconCustomDatabaseCheck,
    saved: IconCustomDatabaseRibbon,
  },
};

export const getSchemaFieldIcon = (
  type: SchemaFieldIconType,
  variant: SchemaFieldIconVariant
) => {
  return fieldIcons[type][variant] ?? IconSection;
};

type SchemaFieldIconProps = SvgIconProps & {
  type: SchemaFieldIconType;
  variant?: SchemaFieldIconVariant;
};

export const SchemaFieldIcon = ({
  type,
  variant = 'default',
  ...rest
}: SchemaFieldIconProps) => {
  const Icon = getSchemaFieldIcon(type, variant);

  if (!Icon) {
    return null;
  }

  return (
    <SvgIcon {...rest}>
      <Icon />
    </SvgIcon>
  );
};
